import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { IAutomaticRenewals } from "@/types/AutomaticRenewals.type";

const API_URL = import.meta.env.VITE_API_URL;

const makeRequestDebounced = createDebounce(makeRequest, 300);
interface GetAutomaticRenewalsParams {
  status?: string | string[];
  search?: string;
  page?: number;
  itemsPerPage?: number;
  orderBy?: string;
  fields?: string;
}
export async function getAutomaticRenewals({
  status = [],
  search = "",
  page = 1,
  itemsPerPage = 10,
  orderBy = "",
  fields = "renterInfo,vehicleInfo,status,errorMessage,createdAt",
}: GetAutomaticRenewalsParams = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
    orderBy,
  });

  const statusParam =
    Array.isArray(status)
      ? status.length > 0
        ? status.join(",")
        : null
      : typeof status === "string" && status.trim() !== ""
        ? status.trim()
        : null;

  if (statusParam) {
    params.append("filters[status]", statusParam);
  }

  if (search) {
    params.append("search", search);
  }

  const url = `${API_URL}/automatic-renewals?${params.toString()}`;

  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    IAutomaticRenewals[]
  > & { totalItems: number };

  return {
    ok: result.ok,
    data: result.data || [],
    totalItems: result.totalItems || 0,
  };
}

export async function getAutomaticRenewalById(logId: string) {
  const url = `${API_URL}/automatic-renewals/${logId}`;
  const result = (await makeRequest(
    url
  )) as ApiResponseType<IAutomaticRenewals>;
  return result;
}
